var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5888 42.6326V51.8949C46.5888 54.7748 44.254 57.1095 41.3742 57.1095C38.4943 57.1095 36.1595 54.7748 36.1595 51.8949V42.6326C36.1595 39.7527 38.4943 37.418 41.3742 37.418C44.254 37.4176 46.5888 39.7524 46.5888 42.6326Z",
    fill: "url(#paint0_linear_110_10963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.841 42.6326V51.8949C103.841 54.7748 101.506 57.1095 98.6261 57.1095C95.7463 57.1095 93.4115 54.7748 93.4115 51.8949V42.6326C93.4115 39.7527 95.7463 37.418 98.6261 37.418C101.506 37.4176 103.841 39.7524 103.841 42.6326Z",
    fill: "url(#paint1_linear_110_10963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.145 52.6231H35.8552C29.4216 52.6231 24.2063 47.4079 24.2063 40.9743V29.6489C24.2063 23.2153 29.4216 18 35.8552 18H104.145C110.579 18 115.794 23.2153 115.794 29.6489V40.9743C115.794 47.4079 110.579 52.6231 104.145 52.6231Z",
    fill: "url(#paint2_linear_110_10963)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2063 40.9739V32.2354H115.794V40.9739C115.794 47.4075 110.578 52.6228 104.145 52.6228H35.8552C29.4216 52.6228 24.2063 47.4075 24.2063 40.9739Z",
    fill: "url(#paint3_linear_110_10963)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2136 18H104.145C110.578 18 115.794 23.2153 115.794 29.6489V40.9743C115.794 47.4079 110.578 52.6231 104.145 52.6231H79.2136V18Z",
    fill: "url(#paint4_linear_110_10963)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6706 40.2209V30.4029C73.6706 29.2069 72.701 28.2373 71.505 28.2373C70.3089 28.2373 69.3394 29.2069 69.3394 30.4029V40.2209C69.3394 41.4169 70.3089 42.3865 71.505 42.3865C72.701 42.3865 73.6706 41.4169 73.6706 40.2209Z",
    fill: "url(#paint5_linear_110_10963)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8652 40.2209V30.4029C81.8652 29.2069 80.8956 28.2373 79.6996 28.2373C78.5035 28.2373 77.5339 29.2069 77.5339 30.4029V40.2209C77.5339 41.4169 78.5035 42.3865 79.6996 42.3865C80.8956 42.3865 81.8652 41.4169 81.8652 40.2209Z",
    fill: "url(#paint6_linear_110_10963)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0595 40.2209V30.4029C90.0595 29.2069 89.09 28.2373 87.8939 28.2373C86.6978 28.2373 85.7283 29.2069 85.7283 30.4029V40.2209C85.7283 41.4169 86.6978 42.3865 87.8939 42.3865C89.09 42.3865 90.0595 41.4169 90.0595 40.2209Z",
    fill: "url(#paint7_linear_110_10963)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.254 40.2209V30.4029C98.254 29.2069 97.2844 28.2373 96.0884 28.2373C94.8923 28.2373 93.9227 29.2069 93.9227 30.4029V40.2209C93.9227 41.4169 94.8923 42.3865 96.0884 42.3865C97.2844 42.3865 98.254 41.4169 98.254 40.2209Z",
    fill: "url(#paint8_linear_110_10963)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M106.448 40.2209V30.4029C106.448 29.2069 105.479 28.2373 104.283 28.2373C103.087 28.2373 102.117 29.2069 102.117 30.4029V40.2209C102.117 41.4169 103.087 42.3865 104.283 42.3865C105.479 42.3865 106.448 41.4169 106.448 40.2209Z",
    fill: "url(#paint9_linear_110_10963)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0877 40.5015H36.2786C33.4125 40.5015 31.0889 38.1779 31.0889 35.3118C31.0889 32.4457 33.4125 30.1221 36.2786 30.1221H54.0877C56.9538 30.1221 59.2774 32.4457 59.2774 35.3118C59.2777 38.1779 56.9541 40.5015 54.0877 40.5015Z",
    fill: "url(#paint10_linear_110_10963)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6612 38.4207C38.3784 38.4207 39.7705 37.0287 39.7705 35.3114C39.7705 33.5942 38.3784 32.2021 36.6612 32.2021C34.944 32.2021 33.5519 33.5942 33.5519 35.3114C33.5519 37.0287 34.944 38.4207 36.6612 38.4207Z",
    fill: "url(#paint11_linear_110_10963)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1833 38.4207C46.9005 38.4207 48.2926 37.0287 48.2926 35.3114C48.2926 33.5942 46.9005 32.2021 45.1833 32.2021C43.4661 32.2021 42.074 33.5942 42.074 35.3114C42.074 37.0287 43.4661 38.4207 45.1833 38.4207Z",
    fill: "url(#paint12_linear_110_10963)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7056 38.4207C55.4228 38.4207 56.8149 37.0287 56.8149 35.3114C56.8149 33.5942 55.4228 32.2021 53.7056 32.2021C51.9884 32.2021 50.5963 33.5942 50.5963 35.3114C50.5963 37.0287 51.9884 38.4207 53.7056 38.4207Z",
    fill: "url(#paint13_linear_110_10963)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5889 81.3113V90.5736C46.5889 93.4535 44.2541 95.7882 41.3743 95.7882C38.4944 95.7882 36.1597 93.4535 36.1597 90.5736V81.3113C36.1597 78.4314 38.4944 76.0967 41.3743 76.0967C44.2541 76.0964 46.5889 78.4311 46.5889 81.3113Z",
    fill: "url(#paint14_linear_110_10963)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.841 81.3113V90.5736C103.841 93.4535 101.506 95.7882 98.6261 95.7882C95.7463 95.7882 93.4115 93.4535 93.4115 90.5736V81.3113C93.4115 78.4314 95.7463 76.0967 98.6261 76.0967C101.506 76.0964 103.841 78.4311 103.841 81.3113Z",
    fill: "url(#paint15_linear_110_10963)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.145 91.3009H35.8551C29.4214 91.3009 24.2062 86.0856 24.2062 79.652V68.3266C24.2062 61.893 29.4214 56.6777 35.8551 56.6777H104.145C110.579 56.6777 115.794 61.893 115.794 68.3266V79.652C115.794 86.0856 110.579 91.3009 104.145 91.3009Z",
    fill: "url(#paint16_linear_110_10963)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2062 79.6516V70.9131H115.794V79.6516C115.794 86.0853 110.578 91.3005 104.145 91.3005H35.8551C29.4214 91.3005 24.2062 86.0853 24.2062 79.6516Z",
    fill: "url(#paint17_linear_110_10963)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2135 56.6777H104.145C110.578 56.6777 115.793 61.893 115.793 68.3266V79.652C115.793 86.0856 110.578 91.3009 104.145 91.3009H79.2135V56.6777Z",
    fill: "url(#paint18_linear_110_10963)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6706 78.8986V69.0807C73.6706 67.8846 72.701 66.915 71.505 66.915C70.3089 66.915 69.3394 67.8846 69.3394 69.0807V78.8986C69.3394 80.0947 70.3089 81.0642 71.505 81.0642C72.701 81.0642 73.6706 80.0947 73.6706 78.8986Z",
    fill: "url(#paint19_linear_110_10963)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8651 78.8986V69.0807C81.8651 67.8846 80.8955 66.915 79.6994 66.915C78.5034 66.915 77.5338 67.8846 77.5338 69.0807V78.8986C77.5338 80.0947 78.5034 81.0642 79.6994 81.0642C80.8955 81.0642 81.8651 80.0947 81.8651 78.8986Z",
    fill: "url(#paint20_linear_110_10963)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0594 78.8986V69.0807C90.0594 67.8846 89.0898 66.915 87.8938 66.915C86.6977 66.915 85.7281 67.8846 85.7281 69.0807V78.8986C85.7281 80.0947 86.6977 81.0642 87.8938 81.0642C89.0898 81.0642 90.0594 80.0947 90.0594 78.8986Z",
    fill: "url(#paint21_linear_110_10963)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.254 78.8986V69.0807C98.254 67.8846 97.2844 66.915 96.0884 66.915C94.8923 66.915 93.9227 67.8846 93.9227 69.0807V78.8986C93.9227 80.0947 94.8923 81.0642 96.0884 81.0642C97.2844 81.0642 98.254 80.0947 98.254 78.8986Z",
    fill: "url(#paint22_linear_110_10963)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.448 78.8986V69.0807C106.448 67.8846 105.479 66.915 104.283 66.915C103.087 66.915 102.117 67.8846 102.117 69.0807V78.8986C102.117 80.0947 103.087 81.0642 104.283 81.0642C105.479 81.0642 106.448 80.0947 106.448 78.8986Z",
    fill: "url(#paint23_linear_110_10963)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0877 79.1792H36.2786C33.4125 79.1792 31.0889 76.8556 31.0889 73.9895C31.0889 71.1231 33.4125 68.7998 36.2786 68.7998H54.0877C56.9538 68.7998 59.2774 71.1234 59.2774 73.9895C59.2777 76.8556 56.9541 79.1792 54.0877 79.1792Z",
    fill: "url(#paint24_linear_110_10963)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6611 77.0995C38.3783 77.0995 39.7704 75.7074 39.7704 73.9902C39.7704 72.2729 38.3783 70.8809 36.6611 70.8809C34.9438 70.8809 33.5518 72.2729 33.5518 73.9902C33.5518 75.7074 34.9438 77.0995 36.6611 77.0995Z",
    fill: "url(#paint25_linear_110_10963)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1833 77.0995C46.9005 77.0995 48.2926 75.7074 48.2926 73.9902C48.2926 72.2729 46.9005 70.8809 45.1833 70.8809C43.4661 70.8809 42.074 72.2729 42.074 73.9902C42.074 75.7074 43.4661 77.0995 45.1833 77.0995Z",
    fill: "url(#paint26_linear_110_10963)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7055 77.0995C55.4227 77.0995 56.8148 75.7074 56.8148 73.9902C56.8148 72.2729 55.4227 70.8809 53.7055 70.8809C51.9883 70.8809 50.5962 72.2729 50.5962 73.9902C50.5962 75.7074 51.9883 77.0995 53.7055 77.0995Z",
    fill: "url(#paint27_linear_110_10963)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5889 119.988V129.25C46.5889 132.13 44.2541 134.465 41.3743 134.465C38.4944 134.465 36.1597 132.13 36.1597 129.25V119.988C36.1597 117.108 38.4944 114.773 41.3743 114.773C44.2541 114.773 46.5889 117.108 46.5889 119.988Z",
    fill: "url(#paint28_linear_110_10963)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.841 119.988V129.25C103.841 132.13 101.506 134.465 98.6261 134.465C95.7463 134.465 93.4115 132.13 93.4115 129.25V119.988C93.4115 117.108 95.7463 114.773 98.6261 114.773C101.506 114.773 103.841 117.108 103.841 119.988Z",
    fill: "url(#paint29_linear_110_10963)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104.145 129.979H35.8552C29.4216 129.979 24.2063 124.763 24.2063 118.33V107.004C24.2063 100.571 29.4216 95.3555 35.8552 95.3555H104.145C110.579 95.3555 115.794 100.571 115.794 107.004V118.33C115.794 124.763 110.579 129.979 104.145 129.979Z",
    fill: "url(#paint30_linear_110_10963)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2063 118.329V109.591H115.794V118.329C115.794 124.763 110.578 129.978 104.145 129.978H35.8552C29.4216 129.978 24.2063 124.763 24.2063 118.329Z",
    fill: "url(#paint31_linear_110_10963)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2136 95.3555H104.145C110.578 95.3555 115.794 100.571 115.794 107.004V118.33C115.794 124.763 110.578 129.979 104.145 129.979H79.2136V95.3555Z",
    fill: "url(#paint32_linear_110_10963)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6705 117.577V107.759C73.6705 106.563 72.7009 105.594 71.5049 105.594C70.3088 105.594 69.3392 106.563 69.3392 107.759V117.577C69.3392 118.773 70.3088 119.743 71.5049 119.743C72.7009 119.743 73.6705 118.773 73.6705 117.577Z",
    fill: "url(#paint33_linear_110_10963)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8651 117.577V107.759C81.8651 106.563 80.8955 105.594 79.6994 105.594C78.5034 105.594 77.5338 106.563 77.5338 107.759V117.577C77.5338 118.773 78.5034 119.743 79.6994 119.743C80.8955 119.743 81.8651 118.773 81.8651 117.577Z",
    fill: "url(#paint34_linear_110_10963)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0594 117.577V107.759C90.0594 106.563 89.0898 105.594 87.8938 105.594C86.6977 105.594 85.7281 106.563 85.7281 107.759V117.577C85.7281 118.773 86.6977 119.743 87.8938 119.743C89.0898 119.743 90.0594 118.773 90.0594 117.577Z",
    fill: "url(#paint35_linear_110_10963)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2539 117.577V107.759C98.2539 106.563 97.2843 105.594 96.0882 105.594C94.8922 105.594 93.9226 106.563 93.9226 107.759V117.577C93.9226 118.773 94.8922 119.743 96.0882 119.743C97.2843 119.743 98.2539 118.773 98.2539 117.577Z",
    fill: "url(#paint36_linear_110_10963)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.448 117.577V107.759C106.448 106.563 105.479 105.594 104.283 105.594C103.087 105.594 102.117 106.563 102.117 107.759V117.577C102.117 118.773 103.087 119.743 104.283 119.743C105.479 119.743 106.448 118.773 106.448 117.577Z",
    fill: "url(#paint37_linear_110_10963)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0877 117.858H36.2786C33.4125 117.858 31.0889 115.534 31.0889 112.668C31.0889 109.802 33.4125 107.479 36.2786 107.479H54.0877C56.9538 107.479 59.2774 109.802 59.2774 112.668C59.2777 115.534 56.9541 117.858 54.0877 117.858Z",
    fill: "url(#paint38_linear_110_10963)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6611 115.776C38.3783 115.776 39.7704 114.384 39.7704 112.667C39.7704 110.95 38.3783 109.558 36.6611 109.558C34.9438 109.558 33.5518 110.95 33.5518 112.667C33.5518 114.384 34.9438 115.776 36.6611 115.776Z",
    fill: "url(#paint39_linear_110_10963)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1833 115.776C46.9005 115.776 48.2926 114.384 48.2926 112.667C48.2926 110.95 46.9005 109.558 45.1833 109.558C43.4661 109.558 42.074 110.95 42.074 112.667C42.074 114.384 43.4661 115.776 45.1833 115.776Z",
    fill: "url(#paint40_linear_110_10963)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7055 115.776C55.4227 115.776 56.8148 114.384 56.8148 112.667C56.8148 110.95 55.4227 109.558 53.7055 109.558C51.9883 109.558 50.5962 110.95 50.5962 112.667C50.5962 114.384 51.9883 115.776 53.7055 115.776Z",
    fill: "url(#paint41_linear_110_10963)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 20,
    r: 16,
    fill: "url(#paint42_linear_110_10963)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_10963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 29.1663C106.937 29.1663 102.833 25.0624 102.833 19.9997C102.833 14.9369 106.937 10.833 112 10.833C117.063 10.833 121.167 14.9369 121.167 19.9997C121.167 25.0624 117.063 29.1663 112 29.1663ZM111.083 22.7497V24.583H112.917V22.7497H111.083ZM111.083 15.4163V20.9163H112.917V15.4163H111.083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_10963",
    x1: 41.2644,
    y1: 47.1874,
    x2: 46.2905,
    y2: 50.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_10963",
    x1: 98.5163,
    y1: 47.1874,
    x2: 103.542,
    y2: 50.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_110_10963",
    x1: 47.5729,
    y1: 12.8844,
    x2: 91.3515,
    y2: 56.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_110_10963",
    x1: 70.0001,
    y1: 45.607,
    x2: 70.0001,
    y2: 53.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_110_10963",
    x1: 102.65,
    y1: 35.3116,
    x2: 116.153,
    y2: 35.3116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_110_10963",
    x1: 73.3989,
    y1: 35.3117,
    x2: 69.7933,
    y2: 35.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_110_10963",
    x1: 81.5935,
    y1: 35.3117,
    x2: 77.9879,
    y2: 35.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_110_10963",
    x1: 89.7878,
    y1: 35.3117,
    x2: 86.1822,
    y2: 35.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_110_10963",
    x1: 97.9823,
    y1: 35.3117,
    x2: 94.3767,
    y2: 35.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_110_10963",
    x1: 106.177,
    y1: 35.3117,
    x2: 102.571,
    y2: 35.3117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_110_10963",
    x1: 45.1833,
    y1: 42.9598,
    x2: 45.1833,
    y2: 31.3653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_110_10963",
    x1: 33.349,
    y1: 31.9996,
    x2: 39.368,
    y2: 38.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    stopColor: "#F3035F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    stopColor: "#D70252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_110_10963",
    x1: 41.8711,
    y1: 31.9996,
    x2: 47.8901,
    y2: 38.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_110_10963",
    x1: 50.3934,
    y1: 31.9996,
    x2: 56.4124,
    y2: 38.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEFFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1201,
    stopColor: "#A3F9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#87EAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#59D19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9235,
    stopColor: "#19AF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A76D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_110_10963",
    x1: 41.2645,
    y1: 85.8661,
    x2: 46.2906,
    y2: 89.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_110_10963",
    x1: 98.5163,
    y1: 85.8661,
    x2: 103.542,
    y2: 89.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_110_10963",
    x1: 47.5728,
    y1: 51.5621,
    x2: 91.3514,
    y2: 95.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_110_10963",
    x1: 70,
    y1: 84.2848,
    x2: 70,
    y2: 92.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_110_10963",
    x1: 102.65,
    y1: 73.9893,
    x2: 116.152,
    y2: 73.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_110_10963",
    x1: 73.3989,
    y1: 73.9895,
    x2: 69.7933,
    y2: 73.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_110_10963",
    x1: 81.5933,
    y1: 73.9895,
    x2: 77.9878,
    y2: 73.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_110_10963",
    x1: 89.7877,
    y1: 73.9895,
    x2: 86.1821,
    y2: 73.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_110_10963",
    x1: 97.9823,
    y1: 73.9895,
    x2: 94.3767,
    y2: 73.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_110_10963",
    x1: 106.177,
    y1: 73.9895,
    x2: 102.571,
    y2: 73.9895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_110_10963",
    x1: 45.1833,
    y1: 81.6375,
    x2: 45.1833,
    y2: 70.0431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_110_10963",
    x1: 33.3489,
    y1: 70.6783,
    x2: 39.3678,
    y2: 76.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    stopColor: "#F3035F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    stopColor: "#D70252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_110_10963",
    x1: 41.8711,
    y1: 70.6783,
    x2: 47.8901,
    y2: 76.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_110_10963",
    x1: 50.3933,
    y1: 70.6783,
    x2: 56.4123,
    y2: 76.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEFFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1201,
    stopColor: "#A3F9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#87EAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#59D19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9235,
    stopColor: "#19AF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A76D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_110_10963",
    x1: 41.2645,
    y1: 124.543,
    x2: 46.2906,
    y2: 128.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_110_10963",
    x1: 98.5163,
    y1: 124.543,
    x2: 103.542,
    y2: 128.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_110_10963",
    x1: 47.5729,
    y1: 90.2398,
    x2: 91.3515,
    y2: 134.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_110_10963",
    x1: 70.0001,
    y1: 122.963,
    x2: 70.0001,
    y2: 130.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_110_10963",
    x1: 102.65,
    y1: 112.667,
    x2: 116.153,
    y2: 112.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_110_10963",
    x1: 73.3988,
    y1: 112.668,
    x2: 69.7932,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_110_10963",
    x1: 81.5933,
    y1: 112.668,
    x2: 77.9878,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_110_10963",
    x1: 89.7877,
    y1: 112.668,
    x2: 86.1821,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_110_10963",
    x1: 97.9821,
    y1: 112.668,
    x2: 94.3766,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_110_10963",
    x1: 106.176,
    y1: 112.668,
    x2: 102.571,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_110_10963",
    x1: 45.1833,
    y1: 120.316,
    x2: 45.1833,
    y2: 108.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_110_10963",
    x1: 33.3489,
    y1: 109.355,
    x2: 39.3678,
    y2: 115.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2568,
    stopColor: "#F3035F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    stopColor: "#D70252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_110_10963",
    x1: 41.8711,
    y1: 109.355,
    x2: 47.8901,
    y2: 115.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA613"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_110_10963",
    x1: 50.3933,
    y1: 109.355,
    x2: 56.4123,
    y2: 115.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEFFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1201,
    stopColor: "#A3F9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#87EAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#59D19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9235,
    stopColor: "#19AF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09A76D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_110_10963",
    x1: 102.4,
    y1: 8.12903,
    x2: 120.254,
    y2: 34.4857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#961D09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_10963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(101 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon500);
export default __webpack_public_path__ + "static/media/icon_500.381a9a1da9265152a73b350d06c4e9ab.svg";
export { ForwardRef as ReactComponent };